import BulletListItemRoot, { Props } from './BulletListItem'

export default function BulletListItem(props: Props) {
  return <BulletListItemRoot {...props} />
}
